const data = function () {
    return {
        buylist: []
    }
};
const computed = {

}
const methods = {


}



export default {
    data,
    computed,
    methods,
}